import(/* webpackMode: "eager" */ "/vercel/path0/src/app/investments/page.jsx");
